import React from 'react';
import { Helmet } from 'react-helmet-async';

// import hooks
import { useRouteInfo } from 'js/hooks/useRouteInfo';

const GenericMetadata = (props) => {
  const { title, description, keywords, og_image, og_description, og_title, og_url } = props;

  const { location } = useRouteInfo();

  const parsedBaseUrl = `${location?.pathname.replace('/', '') || ''}`;

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      <link rel="canonical" href={parsedBaseUrl} />
      {/* <meta property="og:image:url" content={og_image} />
      <meta property="og:image" content={og_image} />
      <meta property="twitter:image" content={og_image} /> */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={og_url !== '' ? og_url : parsedBaseUrl} />
    </Helmet>
  );
};

export default GenericMetadata;
